import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=25a49472&scoped=true&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"
import style0 from "./Layout.vue?vue&type=style&index=0&id=25a49472&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a49472",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25a49472')) {
      api.createRecord('25a49472', component.options)
    } else {
      api.reload('25a49472', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=25a49472&scoped=true&", function () {
      api.rerender('25a49472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GalleryView/Layout.vue"
export default component.exports